import {html} from 'lit-html';
import {ifDefined} from 'lit-html/directives/if-defined';
import {live} from 'lit-html/directives/live';
import {classMap} from 'lit-html/directives/class-map';
import {styleMap} from 'lit-html/directives/style-map';

import TemplateRegistry from '../template/template-registry';
import {
    textHelpUpdate, textNewline, textValueSync, optionClassMap,
    optionDebounce, optionName, optionAutocomplete, optionFontFamily,
    textEditorCollapse, collapse
} from '../template/template-util.js';

TemplateRegistry.templates['textarea'] = (option, config, onChange, onErrorClear, getOption) => html`
    <textarea class="cl-po--input ${classMap(optionClassMap(option))}" id="${option.id}" name="${optionName(option)}" .value=${live(textNewline(option.value))} @input=${optionDebounce(option, (e) => textValueSync(e, option, onChange))} @keyup=${option.params.textUsage ? (e) => textHelpUpdate(e, option) : null}
     ?required=${option.required} minlength=${ifDefined(option.params.min)} maxlength=${ifDefined(option.params.max)} rows=${ifDefined(option.params.rows)} placeholder=${ifDefined(textNewline(option.params.placeholder))} style=${styleMap({ textTransform: option.params.textTransform, fontFamily: optionFontFamily(option, getOption) })} autocomplete="${optionAutocomplete(option)}" form=${ifDefined(config.productFormLink)}>
    </textarea>

    ${option._editor ? (option._layer.params.collapse ?
       html`${collapse(textEditorCollapse(option),TemplateRegistry.templates['text_editor'](option, config, onChange), false, 'cl-po--edit')}` 
     : html`${TemplateRegistry.templates['text_editor'](option, config, onChange)}`): null}
        
    ${option.params.textUsage ? html`
        <div class="cl-po--help cl-po--text-help"></div>
    `: null}
`;